export type ImportStage = {
  id: string;
  name: string;
  position: number;
  is_system: boolean;
};

export function toImportStages(
  stages: { id: string; name: string; is_system?: boolean; position?: number }[],
): ImportStage[] {
  return stages.map((s, i) => ({
    id: s.id,
    name: s.name,
    is_system: !!s.is_system,
    position: s.position ?? i,
  }));
}

export function importableStages(stages: ImportStage[]): ImportStage[] {
  if (!stages.length) return [];
  const maxPos = Math.max(...stages.map((s) => s.position));
  return [...stages]
    .sort((a, b) => a.position - b.position)
    .filter((s) => !(s.is_system && s.position === maxPos));
}

export function resolveImportStageId(
  stages: ImportStage[],
  preferred?: string | null,
): string {
  const opts = importableStages(stages);
  if (!opts.length) return "";
  if (preferred && opts.some((s) => s.id === preferred)) return preferred;
  return opts[0].id;
}
